import { PeTypes } from '@platform/types';
import { useQuery, UseQueryOptions } from 'react-query';

import * as peApi from '../pe.api';

export default (datasetId: string, options?: UseQueryOptions<PeTypes.Dataset>) =>
  useQuery<PeTypes.Dataset>(['dataset', datasetId], () => peApi.getDataset(datasetId), options);
